import React from 'react';
import {hoursInDay} from 'helpers';
import css from './time-grid.module.scss';

export function TimeGrid({ className }) {
  return (
    <ul className={css('timegrid', className)}>
      { hoursInDay.map(hour =>
        <li key={hour} className={hour === '12 PM' ? css.middle : ''}>
          <span className={css.label}>{ hour.replace('12 AM', '') }</span>
        </li>
      ) }
      <li />
    </ul>
  );
}
